module.exports = __webpack_public_path__ + "img/GreekTechFireShipS_ua.4cf5081b.webp";